import { Navigate, useLocation } from "react-router-dom";

import { referralPortalClient } from "@/services/referralPortalClient";

export default function RequirePortalSession({ children }: { children: JSX.Element }) {
  const location = useLocation();
  const session = referralPortalClient.getSession();

  if (!session) {
    return <Navigate to="/refer/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
